import './Planes.css';
import { Link as ScrollLink } from 'react-scroll';

function Planes(props) {

  return (
    <div className="Planes">
      <div className="Planes-content">
        <ScrollLink className="Planes-card" to="Formulario" smooth={true} duration={500} offset={-75} onClick={props.setFocus}><img src={process.env.PUBLIC_URL + '/imgs/card-1.svg'} alt="100 Megas $14999 por mes. Incluye: Instalación sin cargo, primer mes gratis y Claro video." /></ScrollLink>
        <ScrollLink className="Planes-card" to="Formulario" smooth={true} duration={500} offset={-75} onClick={props.setFocus}><img src={process.env.PUBLIC_URL + '/imgs/card-2.svg'} alt="300 Megas desde $17999 por mes. Incluye: Instalación sin cargo, primer mes gratis y Claro video." /></ScrollLink>
        <ScrollLink className="Planes-card" to="Formulario" smooth={true} duration={500} offset={-75} onClick={props.setFocus}><img src={process.env.PUBLIC_URL + '/imgs/card-3.svg'} alt="600 Megas desde $22999 por mes. Incluye: Instalación sin cargo, primer mes gratis y Claro video." /></ScrollLink>
      </div>
      <p className="Planes-leyenda">*OFERTA EXCLUSIVA CLIENTES CLARO O QUE SOLICITEN AMBOS SERVICIOS</p>
    </div>
  );
}

export default Planes;